import { theme } from "../settings/config"
import { schoolInitial } from "../utils/logo.utils"

// Il circolo in un tondo: il suo logo su fondo bianco, o senza logo la sua
// iniziale. Il nome intero non c'è — lo legge chi usa uno screen reader, e
// lo mostra chi mette il tondo da qualche parte (un menu, un tocco).
//
// `tone` dice su cosa sta: "onPrimary" sulla fascia arancione (tondo
// bianco, lettera arancione), "onSurface" su una scheda (tondo pieno,
// lettera bianca), "onTint" su una lezione di un altro circolo, dove un
// tondo arancione griderebbe (tondo del colore delle schede, lettera scura).
function SchoolAvatar({ school, size = 40, tone = "onSurface", style }) {
	const name = school?.schoolName ?? ""
	const logo = school?.logo

	const onPrimary = tone === "onPrimary"
	const onTint = tone === "onTint"

	return (
		<span
			role="img"
			aria-label={name}
			style={{
				width: `${size}px`,
				height: `${size}px`,
				flexShrink: 0,
				borderRadius: "50%",
				overflow: "hidden",
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				boxSizing: "border-box",
				// un logo è disegnato per il bianco, anche nel tema scuro
				background:
					logo || onPrimary ? "#ffffff" : onTint ? theme.colors.surface : theme.colors.primary,
				color: onPrimary
					? theme.colors.primary
					: onTint
						? theme.colors.gunmetal
						: theme.colors.white,
				fontWeight: 700,
				fontSize: `${Math.round(size * 0.45)}px`,
				lineHeight: 1,
				userSelect: "none",
				...style,
			}}>
			{logo ? (
				<img
					src={logo}
					alt=""
					draggable={false}
					style={{
						// il logo è già ritagliato per questo cerchio, aria
						// compresa: lo riempie tutto
						width: "100%",
						height: "100%",
						objectFit: "cover",
						pointerEvents: "none",
					}}
				/>
			) : (
				<span aria-hidden="true">{schoolInitial(name)}</span>
			)}
		</span>
	)
}

export default SchoolAvatar
